// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { InputLabel, Stack } from '@mui/material';
// Others
import { TLabelStyleType } from '~/utils/type/common';
import { EMPTY_STRING } from '~/utils/constants/common';
// Styles, images, icons
import styles from './BaseLabel.module.scss';

type Props = {
  label?: string;
  icon?: string;
  styleType?: TLabelStyleType;
  required?: boolean;
  className?: string;
};

const cx = classNames.bind(styles);

const BaseLabel = (props: Props) => {
  //#region Destructuring Props
  const { icon, label, required = false, styleType = 'input' } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack direction={'row'} spacing={2} alignItems={'center'}>
      {icon && <img src={icon} alt={t('common_alt_img')} className={cx('icon')} />}

      <InputLabel required={required} className={cx(styleType)}>
        {label || EMPTY_STRING}
      </InputLabel>
    </Stack>
  );
};

export default BaseLabel;
